<template>
  <div>
    <span class="caption grey--text text--darken-1">
      {{label}}
    </span>
    <v-select
      v-if="showFavorites"
      v-model="selection"
      :items="favouritesList"
      clearable
      :label="label"
      :disabled="this.$store.getters.specialty === 'endocrinology'"
      hint="Selecione para ver a lista de favoritos"
      persistent-hint
      solo
      class="thin-border"
    />

    <v-autocomplete
      v-if="!showFavorites"
      v-model="selection"
      :loading="loading"
      :items="items"
      :menu-props="{ contentClass: 'icd-autocomplete' }"
      :search-input.sync="search"
      :hint="selection"
      persistent-hint
      clearable
      no-filter
      hide-no-data
      :label="label"
      solo
      class="thin-border"
    >
      <template v-slot:item="data">
        <template>
          <span class="my-1">
            {{ data.item.text }}
          </span>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import * as algolia from '../../services/algolia.js'
export default {
  props: {
    value: { default: null },
    label: { type: String, default: 'Pesquisa de diagnóstico' },
    excludedCodes: { default: () => [] },
    searchIndex: { type: String, default: 'codes_10_cm' },
    itemValue: { type: String, default: 'value' },
    itemText: { type: String, default: 'text' },
    showFavorites: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      favouritesList: []
    }
  },
  computed: {
    selection: {
      get() {
        const [value] = (this.value || ':').split(':')
        return value
      },
      set(value) {
        let item = this.items.find(i => i.value === value)

        if (!item) {
          item = this.favouritesList.find(i => i.value === value)
        }

        const output = value && `${item.value}:${item.text}`
        this.$emit('input', output)
      }
    }
  },
  watch: {
    search(val) {
      if (val && val !== this.selection) {
        this.fetchItems(val)
      }
    }
  },
  methods: {
    async fetchItems(query = '') {
      if (!query.trim()) {
        return
      }
      this.loading = true
      try {
        const data = await algolia.search(
          query,
          this.searchIndex,
          this.$store.getters.accessToken,
          {}
        )
        this.items = data
          .map(item => ({
            text: item[this.itemText],
            value: item[this.itemValue]
          }))
          .filter(item => {
            return !this.excludedCodes.includes(item.value)
          })
      } catch (err) {
        console.error(err)
        this.$store.dispatch('showErrorSnackbar', 'Algo deu errado')
      }

      this.loading = false
    }
  },
  created() {
    algolia
      .search('', this.searchIndex, this.$store.getters.accessToken, {
        favourites: true,
        specialty: this.$store.getters.specialty
      })
      .then(results => {
        this.favouritesList = results.map(item => ({
          text: item[this.itemText],
          value: item[this.itemValue]
        }))
      })

    if (this.value) {
      const [value, text] = (this.value || ':').split(':')
      this.items = [{ value, text }]
    }
  }
}
</script>

<style>
div.icd-autocomplete a {
  height: 100%;
}
</style>
